// extracted by mini-css-extract-plugin
export default {"page":"MyProxiesPage_page__DPfw-","empty":"MyProxiesPage_empty__quxG7"};